import toast from 'react-hot-toast';

export const objectHttp = <T>(request: RequestInfo): Promise<T | null> => {
  return http<T>(request).then(
    (resp) => {
      return resp;
    },
    () => {
      return null;
    }
  );
};

export const boolHttp = (request: RequestInfo): Promise<boolean> => {
  return http(request).then(
    () => {
      return true;
    },
    () => {
      return false;
    }
  );
};

export const http = <T>(request: RequestInfo): Promise<T> => {
  const merged = new Request(request, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    },
  });

  return new Promise((resolve, reject) => {
    fetch(merged)
      .then(async (response) => {
        if (!response.ok) {
          reject(response);
        } else {
          const contentType = response.headers.get('content-type');
          const contentLength = response.headers.get('content-length');
          const status = response.status;
          
          if (status === 204 || contentLength === '0' || !contentType?.includes('application/json')) {
            resolve({} as T);
          } else {
            const text = await response.text();
            if (!text || text.trim() === '') {
              resolve({} as T);
            } else {
              try {
                resolve(JSON.parse(text) as T);
              } catch (parseError) {
                resolve({} as T);
              }
            }
          }
        }
      })
      .catch((err) => {
        toast.error('Request failed');
        reject(err);
      });
  });
};
